function RetailerMap()
{

    const api_base = '/tools/tgl-store/api/';
    const api_key = 'AIzaSyDlp1PmTBAr-NEVU6REVkz2G756T5ovYN8';
    let map, lastOpenedInfoWindow, dTable, retailerData = [], markers = [], circle, tableVisible = true;

    this.init = () => {
        //this.loadJS('https://maps.google.com/maps/api/js?libraries=places,geometry&key=' + api_key);
        //this.loadJS('https://maps.googleapis.com/maps/api/js?loading=async&libraries=places&callback=initTglMap&key=' + api_key);
        this.loadCss('//cdn.datatables.net/2.0.7/css/dataTables.dataTables.min.css');
        this.loadJS('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js');
        this.loadJS('//cdn.datatables.net/2.0.7/js/dataTables.min.js');
        this.loadJS('https://cdn.jsdelivr.net/npm/handlebars@latest/dist/handlebars.js');
        document.addEventListener("DOMContentLoaded", this.onReady);
    }
    this.onReady = () => {
        const $this = this;
        setTimeout(() => {
            $(document).ready(function () {
                $this.setupDataTable();
                /*if (display_fitler === false) {
                    $('#tgl-map-search-form').hide()
                }*/
            })
        },1000)
    }
    this.setupFilters = () => {
        console.log('setupFilters', map);
    }
    this.setupDataTable = () => {
        const visibleColumns = [];
            
        for (let i in visible_columns) {
            if (visible_columns[i]) {
                if (i === 'address') {
                    visibleColumns.push({
                        data: i,
                        render: function (data, type, row) {
                            let link = '';
                            if (row.geometry && row.geometry.lat && row.geometry.lng) {
                                const lat = row.geometry.lat;
                                const lng = row.geometry.lng;
                                link = '<br><a class="genie_link" href="https://www.google.com/maps/dir/?api=1&destination='+lat+','+lng+'" target="_blank">Get Direction</a>';
                            }
                            return data + link;
                        }
                    });
                } else {
                    visibleColumns.push({data: i});
                }
            }
        }
        if(visibleColumns.length) {
            let searchQuery = '';
            let isSearching = false;
            const $this = this;
            
            // Load all data for map by default
            this.loadAllDataForMap();
            
            document.getElementById('customSearchButton').addEventListener('click', () => {
                searchQuery = document.getElementById('customSearchInput').value.trim();
                isSearching = searchQuery.length > 0;
                dTable.ajax.reload();
                // If search is empty, reload all data for map
                if (!isSearching) {
                    $this.loadAllDataForMap();
                }
            });
            document.getElementById('customResetButton').addEventListener('click', () => {
                document.getElementById('customSearchInput').value = '';
                searchQuery = '';
                isSearching = false;
                dTable.ajax.reload();
                // Reload all data for map when reset
                $this.loadAllDataForMap();
            });
            document.getElementById('customSearchInput').addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    document.getElementById('customSearchButton').click();
                }
            });
            tableVisible = true;
            let toolbar = document.createElement('div');
            toolbar.innerHTML = document.getElementById('tgl-map-filter-form').innerHTML;

            dTable = new DataTable('#tgl-data-table', {
                layout: {
                    topStart: toolbar
                },
                /* "dom": 'rtip',*/
                processing: true,
                serverSide: true,
                searching: false,
                info: false,
                ajax: {
                    url: api_base + 'map-data',
                    data: function (d) {
                        d.search = searchQuery; // pass custom search to server
                    },
                    complete: async (resp) => {
                        retailerData = resp.responseJSON.data;
                        // Only update map if we're searching, otherwise keep all markers
                        if (isSearching) {
                            $this.setupMap(retailerData);
                        }
                    }
                },
                columns: visibleColumns
            });
        }else{
            tableVisible = false;
            // Load initial data for map when table is not visible
            this.loadAllDataForMap();
        }
    }
    
    this.loadAllDataForMap = () => {
        fetch(api_base + 'map-data').then((res)=> res.json()).then((resp) => {
            retailerData = resp.data;
            this.setupMap(retailerData);
        })
    }

    this.setupMap = (retailerData) => {
        this.drawMap().then(async () => {
            await this.removeOldMarkers();
            markers = [];
            if (retailerData.length) {
                for (let i in retailerData) {
                    const marker = await this.makeRetailerMarker(retailerData[i]);
                    if (marker) { // Only push valid markers
                        markers.push(marker);
                    }
                }
                this.fitBoundary(markers);
            }
        })
    }
    this.removeOldMarkers = () => {
        if (markers.length) {
            for (let i in markers) {
                if (markers[i] && typeof markers[i].setMap === 'function') {
                    markers[i].setMap(null);
                }
            }
        }
    }
    this.drawMap = async(latitude = 36.778259, longitude = -119.417931) =>
    {
        const { Map } = await google.maps.importLibrary("maps");
        if (!map) {
            console.log('default_zoom_level', default_zoom_level)
            map = new Map(document.getElementById("tgl-map-container"), {
                center: {lat: latitude, lng: longitude},
                zoom: default_zoom_level,
            });
            const THIS = this;
            map.addListener('click', () => {
                THIS.closeAllInfoWindows();
            })
            if(tableVisible)
                this.setupSearch();
            //return this.setupAddressAutoComplete();
        }
    }

    this.setupAddressAutoComplete = async() => {
        const [{ Map }] = await Promise.all([google.maps.importLibrary("places")]);
        const placeAutocomplete = new google.maps.places.Autocomplete(document.getElementById('tgl-address'));
        placeAutocomplete.addListener("place_changed", () => {
            const place = placeAutocomplete.getPlace();
            document.getElementById('tgl-lat').value = place.geometry.location.lat();
            document.getElementById('tgl-lng').value = place.geometry.location.lng();
        });
    }
    this.setupSearch = () => {
        const formElement = document.getElementById('tgl-map-search-form');
        const $THIS = this;
        formElement.addEventListener('submit', (e) => {
            e.preventDefault();
            //dTable.ajax.reload();
            this.searchOnMap();
            console.log($(formElement).serialize());
        });
    }
    this.fitBoundary = (markerArray) =>
    {
        var bounds = new google.maps.LatLngBounds();

        markerArray.forEach(function (mark) {

            mark ? bounds.extend(mark.getPosition()) : '';
        });

        map.fitBounds(bounds);

    }
    this.makeMarker = async(latitude, longitude, image = null) =>
    {
        return new google.maps.Marker({
            position: new google.maps.LatLng(latitude, longitude),
            map: map,
            icon: image
        });
    }
    this.getPopupClass = () => {
        return class Popup extends google.maps.OverlayView {
            position;
            containerDiv;

            constructor(position, content)
            {
                super();
                this.position = position;
                // This zero-height div is positioned at the bottom of the bubble.
                const bubbleAnchor = document.createElement("div");
                bubbleAnchor.classList.add("popup-bubble-anchor");
                bubbleAnchor.innerHTML = content;
                this.containerDiv = document.createElement("div");
                this.containerDiv.classList.add("popup-container");
                this.containerDiv.appendChild(bubbleAnchor);
                // Optionally stop clicks, etc., from bubbling up to the map.
                Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
            }

            /** Called when the popup is added to the map. */
            onAdd()
            {
                this.getPanes().floatPane.appendChild(this.containerDiv);
            }

            /** Called when the popup is removed from the map. */
            onRemove()
            {
                if (this.containerDiv.parentElement) {
                    this.containerDiv.parentElement.removeChild(this.containerDiv);
                }
            }

            /** Called each frame when the popup needs to draw itself. */
            draw()
            {
                const divPosition = this.getProjection().fromLatLngToDivPixel(
                    this.position,
                );
                // Hide the popup when it is far out of view.
                const display =
                    Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                        ? "block"
                        : "none";

                if (display === "block") {
                    this.containerDiv.style.left = divPosition.x + "px";
                    this.containerDiv.style.top = divPosition.y + "px";
                }

                if (this.containerDiv.style.display !== display) {
                    this.containerDiv.style.display = display;
                }
            }
        };
    }
    this.makeRetailerMarker = async(retailer) =>
    {
        //console.log('retailer', retailer);
        //var infowindow = new google.maps.InfoWindow();
        var businessName = retailer.business_name;
        const lat = retailer.geometry.lat;
        const lng = retailer.geometry.lng;
        var address = retailer.address;
        var email = retailer.email;
        var website = retailer.website;

        if (lat || lng) {
            const m = await this.makeMarker(lat, lng);
            //const destination = `${lat},${lng}`;
            const destination = address;
            const direction_link = `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(destination)}`
            /**
             * A customized popup on the map.
             */
            const PopupClass = this.getPopupClass();
            
            
            // Remove HTML tags if any
            const plainWebsite = website
            ? website.replace(/<[^>]*>/g, "").trim()
            : "";

            // Check if empty
            const isWebsiteEmpty = !plainWebsite;

            // Normalize URL (add https:// if missing)
            let normalizedWebsite = plainWebsite;
            if (plainWebsite && !/^https?:\/\//i.test(plainWebsite)) {
            normalizedWebsite = `https://${plainWebsite}`;
            }

            const websiteLine = !isWebsiteEmpty
            ? `<p><b>Website:</b> <a href="${normalizedWebsite}" target="_blank" rel="noopener noreferrer">${plainWebsite}</a></p>`
            : "";


                const content = `
                <div class="popup-bubble">
                    <h4 style="margin: 0 auto;">${businessName}</h4>
                    <p>${address}</p>
                    <p><b>Email:</b> ${email}</p>
                    ${websiteLine}
                    <div class="form-inline align-center mt-2">
                    <a target="_blank" href="${direction_link}" class="tgl-direction-btn mb-2">Directions</a>
                    </div>
                </div>
                `;

            const popup = new PopupClass(new google.maps.LatLng(lat, lng), content)
            m.set('popup', popup);
            m.addListener("click", () => {
                this.closeAllInfoWindows();
                if (m.get('popup')) {
                    m.get('popup').setMap(map);
                }
            });

            return m;
        }

        return false;
    }
    this.closeAllInfoWindows = () => {
        console.log(markers);
        if (markers.length) {
            for (let i in markers) {
                if(typeof markers[i].get === 'function'){
                    const p = markers[i].get('popup');
                    if (p) {
                        p.setMap(null);
                    }
                }
                
            }
        }
    }
    this.loadJS = (url) => {
        var jsElm = document.createElement("script");
        jsElm.type = "application/javascript";
        jsElm.src = url;
        document.body.appendChild(jsElm);
    }
    this.loadCss = (url) => {
        var cssElm = document.createElement("link");
        cssElm.rel = "stylesheet";
        cssElm.href = url;
        document.body.appendChild(cssElm);
    }
    this.showMessage = (container, message, className) => {
        let messageElement = document.createElement("div");
        messageElement.classList.add(className);
        messageElement.innerHTML = message;

        container.prepend(messageElement);
        document.querySelector('form#retailerForm').scrollIntoView();
    }
    this.removeMessage = () => {
        let errorMessage = document.getElementsByClassName('error-message')[0];
        if (errorMessage != null) {
            errorMessage.remove();
        }
        let successMessage = document.getElementsByClassName('success-message')[0];
        if (successMessage != null) {
            successMessage.remove();
        }
    }
    this.createDataView = (context) => {
        const container = document.getElementById('tgl-store-locator-container');
        const template = document.getElementById('tgl-handlebars-template').innerHTML;
        const templateScript = Handlebars.compile(template);
        console.log('context', context)
        const html = templateScript(context)
        container.innerHTML = html;
    }
    this.loadMapData = () => {
        return fetch(api_base + 'map-data' ,)
            .then((res) => res.json())
            .then((json) => {
                return json;

            });
    }

    this.searchOnMap = async() => {
        const {spherical} = await google.maps.importLibrary("geometry")

        const getAddress = $('#tgl-address').val();
        const getLatitude = $('#tgl-lat').val();
        const getLongitude = $('#tgl-lng').val();
        const getDistance = $('#tgl-distance').val();
        const getUnit = $('#tgl-unit').val();
        let radius;
        if (getAddress && getLatitude && getLongitude && getDistance && getUnit) {
            if (getUnit === "km") {
                radius = parseInt(getDistance) * 1000;
            }
            if (getUnit === "miles") {
                radius = parseInt(getDistance) * 1609.34;
            }
            var image = {
                url: 'https://testgenielocator.thegenielab.co.uk/images/loc.png',
                size: new google.maps.Size(25, 41),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 32)
            };
            this.removeOldMarkers();
            const infowindow = new google.maps.InfoWindow();
            const gmarker = await this.makeMarker(getLatitude, getLongitude, image);
            gmarker.addListener("click", () => {
                let html = "<div>";
                html += "<b>" + getAddress + " <br/>";
                html += '</div>';
                infowindow.setContent(html);
                infowindow.open({
                    anchor: gmarker,
                    map,
                });
            });
            markers.push(gmarker);
            if (circle) {
                circle.setMap(null);
            }
            circle = new google.maps.Circle({map: map,
                radius: radius,
                fillOpacity: 0.35,
                fillColor: "#FF0000"});
            circle.bindTo('center', gmarker, 'position');

            var retailerArrLength = retailerData.length;

            if (retailerArrLength) {
                for (var i = 0; i < retailerArrLength; i++) {
                    var rmarker = await this.makeRetailerMarker(retailerData[i]);
                    if (rmarker) {
                        markers.push(rmarker);
                    }
                }
            }

            var bounds = new google.maps.LatLngBounds();

            //hide all table data
            // mapReatilerTable.rows().nodes().to$().hide();

            for (var j = 0; j < markers.length; j++) {
                if (markers[j]) {
                    if (spherical.computeDistanceBetween(markers[j].getPosition(),gmarker.getPosition()) < radius) {
                        var latlng = markers[j].getPosition().lat() + "," + markers[j].getPosition().lng();
                        //$("#mapRetailerDatatable tbody tr[data-latlng='" + latlng + "']").show();
                        bounds.extend(markers[j].getPosition())

                        markers[j].setMap(map);
                    } else {
                        markers[j].setMap(null);
                    }
                }
            }

            map.fitBounds(bounds);
        }
    }
}

const retailerMap = new RetailerMap();
retailerMap.init();